<template>
    <div>
        <DxForm :form-data="formData"
                :items="items"
                :label-location="labelLocation"
                >
             
            <template #form-item="{ data: item }">
                <span class="form-value-style" >
                    {{ item.editorOptions.value }}
                </span>
            </template>
          

        </DxForm>

    
       

    </div>
</template>

<script>
import {  DxForm } from 'devextreme-vue/form';


export default {
        props: {
            createDef:Array,
            routeDef:String,
            modelData:{
                type: Object,
                default: () => ({})
            },
            data: {
                type: Object,
                default: () => ({})
            }
        },

      
        components: {
            DxForm,
        },
        data: function() {
            return {
                formData: this.modelData,
                labelLocation: 'top',
                items:this.createDef,
            
            }
        },
        methods: {
            submit() {
                this.$inertia.post('/'+this.routeDef, this.formData)
            }, 
            customizeItem(item) {
                item.template = 'form-item';
                 
            }           

        },  mounted() {
         console.log("data phucha",this.modelData);
       
       },


}
</script>

<style>
.form-value-style{
    font-weight: 600;
}
.dx-form .dx-field-item-label {  
   font-size: 12px;
   margin-bottom: 0px;
}


</style>